var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscussionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0029 17.0022H15.5365C15.2021 17.0021 14.8897 17.1692 14.7041 17.4474L14.298 18.0566C14.1124 18.3348 13.8 18.5019 13.4656 18.5018H8.53357C8.19915 18.5019 7.88683 18.3348 7.70123 18.0566L7.29506 17.4474C7.10904 17.1691 6.7964 17.0021 6.46171 17.0022H2.99627C2.44383 17.0024 1.99605 17.4502 1.99585 18.0026V19.003C1.99585 19.5337 2.20646 20.0427 2.58172 20.418C2.95698 20.7933 3.46598 21.004 3.99668 21.0039H18.0025C18.5332 21.004 19.0422 20.7933 19.4175 20.418C19.7927 20.0427 20.0033 19.5337 20.0033 19.003V18.0026C20.0032 17.4502 19.5554 17.0024 19.0029 17.0022V17.0022Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0031 17.0022V13.0005",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5012 9.99918V11.4988C14.5012 11.6919 14.6123 11.8677 14.7867 11.9506C14.9611 12.0335 15.1676 12.0086 15.3173 11.8867L17.6351 9.99918H20.0035C21.1085 9.99918 22.0043 9.10338 22.0043 7.99835V3.99668C22.0043 2.89165 21.1085 1.99585 20.0035 1.99585H13.0006C11.8956 1.99585 10.9998 2.89165 10.9998 3.99668V7.99835C10.9998 9.10338 11.8956 9.99918 13.0006 9.99918H14.5012Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99634 17.0023V6.99815C2.99619 6.46745 3.20695 5.95844 3.58221 5.58318C3.95747 5.20792 4.46647 4.99717 4.99717 4.99731H7.99842",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionIcon);
export default __webpack_public_path__ + "static/media/discussion_icon.83a8f825fd0282a203f7b6337a481b44.svg";
export { ForwardRef as ReactComponent };